/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Draught_DetailInputs */



/**
* | output |
* | --- |
* | "A draught survey establishes the weight of cargo loaded or discharged by measuring the vessel's displacement before and after the operation, corrected for tr..." |
*
* @param {Service_Draught_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_draught_detail = /** @type {((inputs?: Service_Draught_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Draught_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("水尺计重通过测量作业前后船舶的排水量来确定装卸货物的重量，并对纵倾、横倾、水密度以及船上的压载水、淡水和燃油进行修正。检验按照联合国欧洲经济委员会（UN ECE）规程进行，为托运人、收货人和租家提供独立的货物数量和数量证书。")
	return /** @type {LocalizedString} */ ("A draught survey establishes the weight of cargo loaded or discharged by measuring the vessel's displacement before and after the operation, corrected for trim, list, water density and the ballast, fresh water and bunkers on board. Carried out to the UN ECE code, it gives shippers, receivers and charterers an independent cargo figure and a certificate of quantity.")
});